/* eslint-disable */
var $ = window.jQuery = require('jquery');

import countries from '@/services/country.json'
import {mapGetters} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'author-user-list',
  components: {},
  props: [],
  data () {
    return {
      userList:null,
      submitted: false,
      userListResults:[],
      is_active: Boolean,
      countryList: [],
      userSubscribeForm: false,
      selectedEmail: '',
      activeStatus: Boolean,
      removeAuthorId:''
    }
  },
  computed: {
    ...mapGetters([
      'getCourseAuthorsGetter',

    ]),
    getUserList() {
      return this.userList = this.$store.getters.getCourseAuthorsGetter.data;
    },
    setInitialStatus() {
      if (this.userList) {
        this.userListResults = this.userList.results
      }
    }

  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.getUserList
    this.setInitialStatus
  },
  methods: {
    getUserListAgain() {
      this.$store.dispatch('getCourseAuthorListFun').then((res) => {}).catch((err) => {})
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/flags/${country.value}.svg`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
    removeAuthorUserFun(id) {
      $('#removAuthorUserModalAgain').modal();
      this.removeAuthorId = id
    },
    removeAuthorUserConfirmationagain(){
      this.$store.dispatch('removeUserAuthorFun', {
        id: this.removeAuthorId
      }).then((res) => {
        if (res.status == '200' || res.status == '201') {
          toast.success(res.data.msg);
          this.getUserListAgain()
        }
      }).catch((err) => {})
    }
  },
  beforeMount() {
    this.getUserList;
  },
  watch: {
    getUserList() {
      return this.$store.getters.getCourseAuthorsGetter
    },
    setInitialStatus() {
      if (this.userList) {
        this.userListResults = this.userList.results
      }
    }
  }
}